var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { removeFromUrlParams } from '../components/Utils';
import { analyticsOverlay } from '../utils/analytics';
import { rhAnalytics } from '../constants/RewardsHub';
var DrawerContext = React.createContext(null);
var DrawerProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    var _c = React.useState(null), details = _c[0], setDetails = _c[1];
    var _d = React.useState(null), eventOutput = _d[0], setEventOutput = _d[1];
    var _e = React.useState(''), drawerType = _e[0], setDrawerType = _e[1];
    var _f = React.useState(false), back = _f[0], setBack = _f[1];
    var isPacDrawersEnabled = ['1', 1].includes(useConfigService('ENABLE_LOYALTY_PAC_DRAWERS'));
    var isBlendedRewardsEnabled = ['1', 1].includes(useConfigService('ENABLE_BLENDED_REWARDS'));
    var onDrawerClose = function () {
        removeFromUrlParams('drawerList');
        setDrawerOpen(false);
        setEventOutput(function (currEventOutput) { return (__assign(__assign({}, currEventOutput), { drawerOpen: false })); });
    };
    var onBackToList = function (listType) {
        var listTypeAdjusted = isBlendedRewardsEnabled ? 'RewardsList' : listType;
        setDrawerType(listTypeAdjusted);
    };
    var onBackFromPAC = function (listTypeStr) {
        if (isPacDrawersEnabled)
            setDrawerOpen(true);
        else
            onBackToList(listTypeStr);
    };
    var openListPerks = React.useCallback(function () {
        setDrawerType('PerksList');
        setDrawerOpen(true);
    }, []);
    var openListOffers = React.useCallback(function () {
        setDrawerType('OffersList');
        setDrawerOpen(true);
    }, []);
    var openListRewards = React.useCallback(function () {
        setDrawerType('RewardsList');
        setDrawerOpen(true);
    }, []);
    var openDetailsController = React.useCallback(function (_a) {
        var perk = _a.perk, showBack = _a.showBack, evtData = _a.eventOutput, openType = _a.openType;
        setDetails(perk); // TODO: Possibly no longer used after end of 2024Q2
        setDrawerType(openType);
        setDrawerOpen(true);
        setEventOutput(__assign(__assign({}, evtData), { drawerOpen: true }));
        if (showBack)
            setBack(true);
    }, []);
    var openSelectionPerks = React.useCallback(function (props) {
        return openDetailsController(__assign(__assign({}, props), { openType: 'PerkSelection' }));
    }, []);
    var openDetailsPerks = React.useCallback(function (props) {
        analyticsOverlay(rhAnalytics.perkDetailsDrawer);
        openDetailsController(__assign(__assign({}, props), { openType: 'PerkDetails' }));
    }, []);
    var openDetailsOffers = React.useCallback(function (props) {
        analyticsOverlay(rhAnalytics.offerDetailsDrawer);
        openDetailsController(__assign(__assign({}, props), { openType: 'OfferDetails' }));
    }, []);
    var openDetailsChallenge = function (payload) {
        var _a;
        setDetails((_a = payload === null || payload === void 0 ? void 0 : payload.data) !== null && _a !== void 0 ? _a : null);
        setBack(Boolean(payload === null || payload === void 0 ? void 0 : payload.showBack));
        setDrawerOpen(true);
        setDrawerType('ChallengeDetails');
    };
    return (React.createElement(DrawerContext.Provider, { value: {
            drawerOpen: drawerOpen,
            setDrawerOpen: setDrawerOpen,
            onDrawerClose: onDrawerClose,
            details: details,
            setDetails: setDetails,
            drawerType: drawerType,
            setDrawerType: setDrawerType,
            back: back,
            setBack: setBack,
            onBackToList: onBackToList,
            onBackFromPAC: onBackFromPAC,
            eventOutput: eventOutput,
            setEventOutput: setEventOutput,
            openListPerks: openListPerks,
            openListOffers: openListOffers,
            openListRewards: openListRewards,
            openSelectionPerks: openSelectionPerks,
            openDetailsPerks: openDetailsPerks,
            openDetailsOffers: openDetailsOffers,
            openDetailsChallenge: openDetailsChallenge,
            isPacDrawersEnabled: isPacDrawersEnabled,
        } }, children));
};
export { DrawerProvider, DrawerContext };
